var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.t(interpolate( gettext("Использованный сервис не вернул информацию о вашем Email. Продолжите %(linkS)s%(regUrl)s%(linkM)sрегистрацию%(linkE)s, заполнив поле Email вручную."), {'linkS': '<a href="', 'linkM': '">', 'linkE': '</a>', 'regUrl': t.d("registrationUrl",c,p,1)||""}, true)));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{{ ___0___ }}}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/email_not_found.html
// module id = 187
// module chunks = 4